import axios from "axios";

/** Fetch a single product from DHC embedded commerce API. */
export async function fetchLiveProduct(apiBase, productId, { destination, currency, shippingSpeed } = {}) {
  const { data } = await axios.get(`${apiBase}/products/${encodeURIComponent(productId)}`, {
    params: {
      destination: destination || "BB",
      currency: currency || "USD",
      shipping_speed: shippingSpeed,
      _t: Date.now(),
    },
    timeout: 25000,
  });
  return data;
}
